import PropTypes from "prop-types";
import React, {useState, useEffect} from "react";
import { Auth } from "aws-amplify";
import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter, Link } from "react-router-dom";
import {getUserDetails} from "helpers/backend_helper"
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser } from "../../store/actions";

// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo_black-c.png";


const Login = props => {

   //meta title
  document.title="Login | DoctorChamp";

  const dispatch = useDispatch();

  const [rememberMeChecked, setRememberMeChecked] = useState(false)
  const [savedUserId, setSavedUserId] = useState('')
  const [loginError, setLoginError] = useState()
  const [inProgress, setInProgress] = useState(false)
  const [redirectToURL, setRedirectToURL] = useState()

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: savedUserId || '',
      password: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      handleValidSubmit(values)
    }
  });

  useEffect(() => {
    if (localStorage.getItem("rememberMeKey")) {
      const obj = (localStorage.getItem("rememberMeKey"))
      setRememberMeChecked(true)
      setSavedUserId(obj)
    }
  }, [props.success])

  useEffect(() => {
    if (document.location.search) {
      let params = new URLSearchParams(document.location.search);
      if(params && params.get("redirectURL")){
        setRedirectToURL(params.get("redirectURL"))
      }
    }
  }, [])

  const handleValidSubmit = (values) => {
    setInProgress(true)
    setLoginError()
    //console.log('values:'+JSON.stringify(values))

    if(rememberMeChecked){
      localStorage.setItem("rememberMeKey", (values.email))
    }
    else{
      localStorage.removeItem("rememberMeKey")
    }

    Auth.signIn({
      username: (values.email),
      password: values.password,
    })
      .then((user) => {
        
        Auth.currentUserInfo().then((result) => {
          //console.log('result:',JSON.stringify(result))
          localStorage.setItem("olympUser", JSON.stringify(result))
        })
        //setEmail("");
        //setPassword("");
        setInProgress(false)
        //console.log(user);
        
        //localStorage.setItem("userSession", JSON.stringify(user.signInUserSession))
        if(redirectToURL && redirectToURL != ''){
          props.history.replace(redirectToURL)
        }else{
          props.history.push('/dashboard')
        }
      })
      .catch((err) => {
        if(err.code && err.code=='UserNotConfirmedException'){
          setLoginError('Your email id is not verified.')
        }
        else if(err.code && err.code=='NotAuthorizedException'){
          setLoginError('Login Failed. Please check your email or password')
        }
        console.log('Error:',JSON.stringify(err));
        setInProgress(false)
      })
    //dispatch(loginUser(values, props.history))
  }

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }));


  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {loginError ? 
                      <Alert color="danger"> 
                        <span className="alert-icon"><i className="bx bx-error-circle me-1 font-size-18 align-middle"></i></span>
                        <span className="alert-text align-middle">{loginError}</span>
                      </Alert>
                      : null}

                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                        />
                        {validation.touched.password && validation.errors.password ? (
                          <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                        ) : null}
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                          disabled={inProgress}
                        >
                          <Row>
                            <Col>
                            </Col>
                            <Col>
                            Log In
                            </Col>
                            <Col className="text-end">
                              {inProgress && <i className="bx bx-loader bx-spin font-size-16 align-middle ms-2 me-2"></i>}
                            </Col>
                          </Row>
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Don&#39;t have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
